/**
 * Lectura pública del sitio: planes del catálogo del SuperAdmin y estado de la plataforma.
 * Los precios del sitio salen SIEMPRE de acá, para que coincidan con lo que se cobra.
 */
import { useEffect, useState } from 'react';

const API = import.meta.env.VITE_API_URL || '';
let cachePlanes = null;

export async function leer(ruta) {
  const r = await fetch(`${API}/api/public/${ruta}`);
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export function usePlanes() {
  const [estado, setEstado] = useState({ planes: cachePlanes, error: false });
  useEffect(() => {
    if (cachePlanes) return undefined;
    let vivo = true;
    leer('planes')
      .then(d => { cachePlanes = d.planes || []; if (vivo) setEstado({ planes: cachePlanes, error: false }); })
      .catch(() => { if (vivo) setEstado({ planes: null, error: true }); });
    return () => { vivo = false; };
  }, []);
  const lista = estado.planes || [];
  const desde = lista.length ? Math.min(...lista.map(p => p.precioMensual)) : null;
  return { planes: estado.planes, error: estado.error, desde };
}

export async function enviarDemo(datos) {
  const r = await fetch(`${API}/api/public/demo`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(datos) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok || !d.success) throw new Error(d.error || `HTTP ${r.status}`);
  return d;
}
